import styled from 'styled-components';

export const StyledChapter = styled.div`
  display: flex;
  justify-content: center;
  background: white;
  height: 100%;
  overflow-x: hidden;
  overflow-y: auto;
`;